export default __webpack_public_path__ + "static/media/aileron-regular-webfont.94231e28.woff2";